import _ from 'lodash';
import { MenuItem } from 'material-ui';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { disableFormSubmit } from 'src/actions/form-submit';
import { searchRatioCustomers } from 'src/actions/ratio';
import {
    genderMenuItems,
    languageMenuItems,
    renderInput,
    renderSelectField,
} from 'src/components/misc/redux-form-helpers';
import { isBlank } from 'src/components/misc/validations';
import { IconLabel } from 'src/components/administration/IconLabel';

class CustomerAdministrationImportForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    componentDidMount() {
        this.props.disableFormSubmit(true);
    }

    componentWillUnmount() {
        this.props.disableFormSubmit(false);
    }

    componentDidUpdate() {
        /* Disable form if the operator did not select a customer and chose a customer group for said customer */
        if (this.props.selectedCustomer && this.props.customerGroupId) {
            this.props.disableFormSubmit(false);
        } else if (!this.props.selectedCustomer || !this.props.customerGroupId) {
            this.props.disableFormSubmit(true);
        }
    }

    handleSearchKeyword(keyword) {
        this.props.searchRatioCustomers(keyword);
    }

    render() {
        const { keyword, t } = this.props;

        return (
            <>
                <form className="form-horizontal" onSubmit={this.props.onSubmit}>
                    <div className="row">
                        <div className="col-md-9">
                            <Field name="keyword" label={t('common_phrases.keyword')} component={renderInput} />
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-blue btn-flex pull-right voffset"
                                onClick={() => {
                                    this.handleSearchKeyword(keyword);
                                }}
                                type="button">
                                <IconLabel icon="search" text={t('common_phrases.search')} />
                            </button>
                        </div>
                    </div>
                    <div className="row voffset">
                        <div className="col-md-3">
                            <Field
                                name="customerGroupId"
                                label={`${t('customer_group.group')} *`}
                                component={renderSelectField}>
                                {this.getCustomerGroupMenuItems()}
                            </Field>
                        </div>
                        <div className="col-md-3">
                            <Field name="gender" label={`${t('contact_data.gender')} *`} component={renderSelectField}>
                                {genderMenuItems(t)}
                            </Field>
                        </div>
                        <div className="col-md-3">
                            <Field
                                name="transferNumber"
                                label={t('contact_data.transfer_number')}
                                component={renderInput}
                            />
                        </div>
                        <div className="col-md-3">
                            <Field name="language" label={`${t('language')}`} component={renderSelectField}>
                                {languageMenuItems()}
                            </Field>
                        </div>
                    </div>
                </form>
            </>
        );
    }

    getCustomerGroupMenuItems() {
        const { t, customerGroups } = this.props;

        return _.map(customerGroups.items, customerGroup => (
            <MenuItem
                key={customerGroup.id}
                value={customerGroup.id}
                primaryText={t(`customer_groups.id.${customerGroup.id}`)}
            />
        ));
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};
    if (isBlank(values.gender)) errors.gender = t('error_missing.fill_in_gender');
    return errors;
};

const selector = formValueSelector('customerAdministrationImportForm');

export default connect(
    state => ({
        keyword: selector(state, 'keyword'),
        customerGroupId: selector(state, 'customerGroupId'),
    }),
    {
        searchRatioCustomers,
        disableFormSubmit,
    },
    null,
    { withRef: true },
)(
    reduxForm({
        form: 'customerAdministrationImportForm',
        validate,
    })(CustomerAdministrationImportForm),
);
